import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import VideoPlayer from './VideoPlayer';

const ProjectMedia = ({
  video,
  image,
  localVideo,
  disableAutoPause,
  playHomeFeatured,
  projectSlug,
}) => {
  // Videos
  if (video) {
    // Video without web frame, fill the square
    return (
      <div>
        <VideoPlayer
          url={video}
          localVideoUrl={localVideo}
          wrapperClass={`squareBox noPointerEvents`}
          autoplay
          cover={image}
          disableAutoPause={disableAutoPause}
          playHomeFeatured={playHomeFeatured}
          projectSlug={projectSlug}
        />
      </div>
    );
  }
  // Images
  else {
    // Image without web frame, fill the square
    return (
      <div className={`squareBox`}>
        <GatsbyImage
          image={getImage(image?.localFile)}
          alt={image.alternativeText ?? ''}
          className={`mediaBoxInner`}
        />
      </div>
    );
  }
};

export default ProjectMedia;
